import { IconLeftOutlined, IconRightOutlined } from "@suse-o11y/icons";
import type { Signal } from "@suse-o11y/signal";
import { useNow } from "@suse-o11y/use-now";
import React from "react";

import type { TimeRange } from "../../../../../app/state/view/timeline/TimeRange";
import { IconButton, type IconButtonSize } from "../../Buttons";

export interface TimeRangeSelectorButtonShiftLeftProps {
	tooltip: string;
	timeRange: Signal<TimeRange>;
	size?: IconButtonSize;
	disabled?: boolean;
}

export const TimeRangeSelectorButtonShiftLeft: React.FC<TimeRangeSelectorButtonShiftLeftProps> = ({
	tooltip,
	timeRange,
	size,
	disabled = false,
}) => (
	<IconButton
		data-testid="time-range-selector-button-shift-left"
		disabled={disabled}
		icon={<IconLeftOutlined />}
		onClick={() => {
			timeRange.write((current) => current.shiftLeft());
		}}
		size={size}
		tooltip={tooltip}
		tooltipPosition="topLeft"
	/>
);

export interface TimeRangeSelectorButtonShiftRightProps {
	tooltip: string;
	timeRange: Signal<TimeRange>;
	size?: IconButtonSize;
	disabled?: boolean;
}

export const TimeRangeSelectorButtonShiftRight: React.FC<TimeRangeSelectorButtonShiftRightProps> = ({
	tooltip,
	timeRange,
	size,
	disabled = false,
}) => {
	const rightTimeRange = useNow<TimeRange>({
		transform: (now, monitor) => timeRange.read(monitor).shiftRight(now),
		compare: (left, right) => left.isEqual(right),
		pause: disabled,
	});

	const isDisabled = useNow({
		transform: (now) => disabled || rightTimeRange.isInFuture(now),
		pause: disabled,
	});

	return (
		<IconButton
			data-testid="time-range-selector-button-shift-right"
			disabled={isDisabled}
			icon={<IconRightOutlined />}
			onClick={() => timeRange.write(rightTimeRange)}
			size={size}
			tooltip={tooltip}
		/>
	);
};
